export default __webpack_public_path__ + "static/media/github.94765f67.png";